module.exports = __webpack_public_path__ + "static/media/O1.fd530bf1.jpg";